import { isCurrentConversationVideo } from 'modules/appointmentInfo/selectors/currentAppointment';
import { logAppointmentParticipantsEvents } from 'modules/common/actions/logAppointmentParticipantsEvents';

import createAction from './';

export const SET_INTERNET_SLOW = createAction('SET_INTERNET_SLOW');
export const ADD_SLOW_INTERNET_STATS = createAction('ADD_SLOW_INTERNET_STATS');
export const INTERNET_ESTABLISHED = createAction('INTERNET_ESTABLISHED');
export const ADD_SLOW_INTERNET_TOAST = createAction('ADD_SLOW_INTERNET_TOAST');
export const REMOVE_SLOW_INTERNET_TOAST = createAction('REMOVE_SLOW_INTERNET_TOAST');


export const addSlowInternetToast = () => ({ type: ADD_SLOW_INTERNET_TOAST });
export const removeSlowInternetToast = () => ({ type: REMOVE_SLOW_INTERNET_TOAST });

const INTERNET_SPEED_TRASHHOLD = 2;

export const onPing = (internetSpeed) => (dispatch, getState) => {
  const state = getState();
  if (!state.appointmentInfo.currentAppointment.appointmentId || !isCurrentConversationVideo(state)) {
    return null;
  }

  const { isInternetSlow, slowInternetStats, slowInternetStartTime } = state.conference.internetMeter;
  const { appointmentId } = state.appointmentInfo.currentAppointment;
  const data = Math.min(...slowInternetStats) + 'Mb';

  if (internetSpeed > INTERNET_SPEED_TRASHHOLD) {
    if (isInternetSlow) {
      dispatch(logAppointmentParticipantsEvents({
        appointmentId,
        eventType: 'SLOW_INTERNET_CONNECTION',
        startAt: slowInternetStartTime,
        endAt: new Date().getTime(),
        data,
      }));
      return dispatch({ type: INTERNET_ESTABLISHED });
    }

    return null;
  }

  if (isInternetSlow) {
    return dispatch({ type: ADD_SLOW_INTERNET_STATS, payload: { internetSpeed } });
  }

  dispatch(addSlowInternetToast());

  return dispatch({ type: SET_INTERNET_SLOW, payload: { internetSpeed, date: new Date().getTime() } });
};
